import Base from './components/cells/Base';
import Avatar from './components/cells/Avatar';

export default function AvatarCell() {}

AvatarCell.prototype.init = function (params) {
    this.eGui = Base(Avatar(params), params);
    return;
};

AvatarCell.prototype.getGui = function () {
    return this.eGui;
};
